<se-fe-card>
  <se-fe-card-header
    [seFeDataTitle]="'SALE_DETAIL.TYPES.' + saleSummaryTitle | translate"
    [seFeDataSubtitle]="sale.description"
    [seFeDataHeavyBorder]="true">
  </se-fe-card-header>
  <se-fe-card-content>
    @for (saleItemRegister of saleItemRegisters; track saleItemRegister) {
      <div pl-grid="tight">
        <div pl-grid-el pl-grid="nowrap"
          test-id="sale-item">
          @if (item(saleItemRegister).full_name === 'Bill Amount') {
            <span
              class="pl-text--light"
              [textContent]="'SALE_DETAIL.SUMMARY.bill_amount' | translate">
            </span>
          }
          @if (item(saleItemRegister).full_name !== 'Bill Amount') {
            <span
              class="pl-text--light"
              [textContent]="item(saleItemRegister).full_name">
            </span>
          }
        </div>
        @if (saleItemRegister.quantity > 1) {
          <div pl-grid="shrink@phone" pl-grid-el>
            <span class="pl-text--right">{{ saleItemRegister.price | displayCurrency:sale.currency_symbol }}</span>
          </div>
        }
        @if (saleItemRegister.quantity > 1) {
          <div pl-grid="shrink@phone" pl-grid-el>
            <span class="pl-text--right">x{{ saleItemRegister.quantity }}</span>
          </div>
        }
        <div pl-grid="shrink@phone" pl-grid-el>
          <span class="pl-text--right">{{ saleItemRegister.amount | displayCurrency:sale.currency_symbol }}</span>
        </div>
      </div>
    }

    @if (showSubTotalAmount) {
      <div test-id="subtotal">
        <hr class="pl-divider"/>
        <div pl-grid="align-middle">
          <div pl-grid-el pl-grid="1/2@phone">
            <strong [textContent]="'SALE_DETAIL.SUMMARY.subtotal' | translate"></strong>
          </div>
          <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
            <strong>{{ subtotalRegister.amount | displayCurrency:sale.currency_symbol }}</strong>
          </div>
        </div>
      </div>
    }

    @for (discountRegister of discountRegisters; track discountRegister) {
      <div
        pl-grid="align-middle tight"
        test-id="discounted-amount">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.discounted' | translate"></span>
        </div>
        <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
          {{ discountRegister.amount | displayCurrency:sale.currency_symbol }}
        </div>
      </div>
    }

    @for (feeRegister of feeRegisters; track feeRegister) {
      <div
        pl-grid="align-middle tight"
        test-id="processing-fees">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.management_fee' | translate"></span>
        </div>
        @if (feeRegister.amount) {
          <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
            {{ feeRegister.amount | displayCurrency:sale.currency_symbol }}
          </div>
        }
        @if (!feeRegister.amount) {
          <div
            pl-grid-el pl-grid="1/2@phone"
            class="pl-text--right"
            [textContent]="'SALE_DETAIL.SUMMARY.calculated_at_checkout' | translate">
          </div>
        }
      </div>
    }

    @for (salesTaxRegister of salesTaxRegisters; track salesTaxRegister) {
      <div
        pl-grid="align-middle tight"
        test-id="sales-tax">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.sales_tax' | translate"></span>
        </div>
        @if (salesTaxRegister.amount) {
          <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
            {{ salesTaxRegister.amount | displayCurrency:sale.currency_symbol }}
          </div>
        }
        @if (!salesTaxRegister.amount) {
          <div
            pl-grid-el pl-grid="1/2@phone"
            class="pl-text--right"
            [textContent]="'SALE_DETAIL.SUMMARY.calculated_at_checkout' | translate">
          </div>
        }
      </div>
    }
    <hr class="pl-divider"/>

    <div pl-grid="fixed" test-id="total">
      <div pl-grid-el pl-grid="1/2@phone">
        <strong [textContent]="'SALE_DETAIL.SUMMARY.total' | translate"></strong>
      </div>
      <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
        <strong [textContent]="totalRegister?.amount | displayCurrency:sale.currency_symbol"></strong>
      </div>
    </div>

    @if (creditRegisters?.length) {
      <div
        pl-grid="align-middle tight"
        test-id="total-credited-amount">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.credited' | translate"></span>
          <span>&nbsp;</span>
          @if (!showAdjustments) {
            <span class="pl-link pl-help-text"
              (click)="toggleShowAdjustmentsDetail()"
              [textContent]="'SALE_DETAIL.SUMMARY.show_details' | translate">
            </span>
          }
          @if (showAdjustments) {
            <span class="pl-link pl-help-text"
              (click)="toggleShowAdjustmentsDetail()"
              [textContent]="'SALE_DETAIL.SUMMARY.hide_details' | translate">
            </span>
          }
        </div>
        <div pl-grid-el pl-grid="1/2@phone"
          class="pl-text--right">{{ totalCreditedRegister.amount | displayCurrency:sale.currency_symbol }}
        </div>
      </div>
    }

    @if (showAdjustments) {
      <div test-id="credited-amounts">
        <div pl-grid-el pl-grid="1/1@phone">
          @for (creditRegister of creditRegisters; track creditRegister) {
            <div pl-grid="align-middle tight"
              class="pl-text--xsmall"
              style="margin:0 24px"
              >
              <div pl-grid-el pl-grid="1/1@phone">
            <span [textContent]="'SALE_DETAIL.SUMMARY.amount_on_date' | translate: {
                amount: (-creditRegister.amount | displayCurrency:sale.currency_symbol),
                date: (creditRegister.created_at | date: 'MMM d, yyyy')
               }">
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (paymentRegisters.length) {
      <div
        pl-grid="align-middle tight"
        test-id="total-paid-amount">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.paid' | translate"></span>
          <span>&nbsp;</span>
          @if (!showPaymentDetail) {
            <span class="pl-link pl-help-text"
              (click)="toggleShowPaymentDetail()"
              [textContent]="'SALE_DETAIL.SUMMARY.show_details' | translate">
            </span>
          }
          @if (showPaymentDetail) {
            <span class="pl-link pl-help-text"
              (click)="toggleShowPaymentDetail()"
              [textContent]="'SALE_DETAIL.SUMMARY.hide_details' | translate">
            </span>
          }
        </div>
        <div pl-grid-el pl-grid="1/2@phone"
          class="pl-text--right">{{ totalPaidRegister.amount | displayCurrency:sale.currency_symbol }}
        </div>
      </div>
    }

    @if (showPaymentDetail) {
      <div>
        <div pl-grid-el pl-grid="1/1@phone">
          @for (paymentRegister of paymentRegisters; track paymentRegister) {
            <div class="pl-text--xsmall"
              pl-grid="align-middle tight"
              style="margin:0 24px"
              >
              <div pl-grid-el pl-grid="1/1@phone">
                <span
              [textContent]="'SALE_DETAIL.SUMMARY.amount_on_date' | translate: {
                amount: (-paymentRegister.amount | displayCurrency:sale.currency_symbol),
                date: (paymentRegister.created_at | date: 'MMM d, yyyy')
              }">
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (refundAdjustments.length) {
      <div pl-grid="align-middle tight">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.refund_adjustments' | translate"></span>
          <span>&nbsp;</span>
          @if (!showRefundsDetail) {
            <span class="pl-link pl-help-text" (click)="toggleShowRefundsDetail()"
              [textContent]="'SALE_DETAIL.SUMMARY.show_details' | translate">
            </span>
          }
          @if (showRefundsDetail) {
            <span class="pl-link pl-help-text" (click)="toggleShowRefundsDetail()"
              [textContent]="'SALE_DETAIL.SUMMARY.hide_details' | translate">
            </span>
          }
        </div>
        <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">{{ totalRefundsAmount |
          displayCurrency:sale.currency_symbol }}
        </div>
      </div>
    }

    @if (showRefundsDetail) {
      <div>
        <div pl-grid-el pl-grid="1/1@phone">
          @for (refund of refundAdjustments; track refund) {
            <div class="pl-text--xsmall" pl-grid="align-middle tight" style="margin:0 24px"
              >
              <div pl-grid-el pl-grid="1/1@phone">
            <span [textContent]="'SALE_DETAIL.SUMMARY.amount_on_date' | translate: {
                  amount: (refund.amount | displayCurrency:sale.currency_symbol),
                  date: (refund.created_at | date: 'MMM d, yyyy')
                }">
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (voided) {
      <div
        pl-grid="align-middle tight"
        test-id="voided-amount">
        <div pl-grid-el pl-grid="1/2@phone">
          <span class="pl-text--light" [textContent]="'SALE_DETAIL.SUMMARY.voided' | translate"></span>
        </div>
        <div pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
          {{ -totalRegister.amount | displayCurrency:sale.currency_symbol }}
        </div>
      </div>
    }

    @if (showOutstandingAmount) {
      <hr class="pl-divider"/>
    }

    @if (showOutstandingAmount) {
      <div pl-grid="fixed" test-id="outstanding-amount">
        <strong pl-grid-el pl-grid="1/2@phone" [textContent]="'SALE_DETAIL.SUMMARY.outstanding' | translate"></strong>
        <strong pl-grid-el pl-grid="1/2@phone" class="pl-text--right">
          {{ amountOutstandingRegister.amount | displayCurrency:sale.currency_symbol }}
        </strong>
      </div>
    }
  </se-fe-card-content>
</se-fe-card>
